import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Section from '../components/Section';

export default () => (
  <Section id="quality">
    <h1><FormattedHTMLMessage id="pages:quality:title" /></h1>
    <FormattedHTMLMessage id="pages:quality:description" />
  </Section>
);



// WEBPACK FOOTER //
// ./src/sections/Quality.js